var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta__container"},[_c('div',{staticClass:"inner"},_vm._l((JSON.parse(_vm.ctas)),function(cta,index){return _c('call-to-action',{key:index,attrs:{"title":cta.title,"excerpt":cta.excerpt,"permalink":cta.link,"background":cta.background_image}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib?{}!./scripts/vue/CallToActionContainer.vue?vue&type=template&id=6a702dde&scoped=true&
// module id = 177
// module chunks = 0